import { useMemo } from "react";
import TestimonialCard from "../TestimonialCard/TestimonialCard";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination } from "swiper/modules";
import brazil from "@/assets/countries/br.svg";
import switzerland from "@/assets/countries/ch.svg";
import india from "@/assets/countries/in.svg";
import usa from "@/assets/countries/us.svg";
import germany from "@/assets/countries/gb.svg";
import italy from "@/assets/countries/it.svg";
import sweden from "@/assets/countries/se.svg";
import norway from "@/assets/countries/Norway.svg";
import uk from "@/assets/countries/United-Kingdom.svg";
import uae from "@/assets/countries/ae.svg";
import japan from "@/assets/countries/jp.svg";
import spain from "@/assets/countries/Spain.svg";

export type TestimonialStripItem = {
  name: string;
  flag: string;
  quote: string;
  value: string;
};

const testimonials: TestimonialStripItem[] = [
  {
    name: "Ryan Mitchell",
    flag: usa,
    quote:
      "The evaluation process was transparent and fair. I appreciate how URFX focuses on consistency rather than just profits. Their platform helped me develop better risk management skills.",
    value: "$7,842.15",
  },
  {
    name: "Carlos Silva",
    flag: brazil,
    quote:
      "After trying multiple prop firms, URFX stands out for their reasonable drawdown limits. I can trade my strategy without constantly worrying about hitting arbitrary restrictions.",
    value: "$12,567.89",
  },
  {
    name: "Anna Weber",
    flag: germany,
    quote:
      "The community aspect is fantastic. Being able to connect with other funded traders and share insights has improved my trading significantly. URFX built something special here.",
    value: "$4,691.33",
  },
  {
    name: "Marco Bianchi",
    flag: italy,
    quote:
      "I was skeptical at first, but URFX proved me wrong. Their profit splits are competitive, and they actually celebrate your wins. It feels like a true partnership.",
    value: "$8,924.77",
  },
  {
    name: "Erik Lindqvist",
    flag: sweden,
    quote:
      "The educational resources they provide are top-notch. Even as an experienced trader, I learned new techniques that improved my performance significantly.",
    value: "$6,173.94",
  },
  {
    name: "Priya Sharma",
    flag: india,
    quote:
      "What I love most is the flexibility in trading hours. URFX understands that markets move differently, and they don't penalize you for adapting your schedule accordingly.",
    value: "$9,385.42",
  },
  {
    name: "Brandon Johnson",
    flag: usa,
    quote:
      "URFX's demo environment perfectly mirrors live trading conditions. When I transitioned to the real account, there were no surprises or slippage issues.",
    value: "$15,234.67",
  },
  {
    name: "Gabriel Costa",
    flag: brazil,
    quote:
      "The scaling program is aggressive in the best way. I went from a $25K account to $100K faster than I ever thought possible with their performance-based increases.",
    value: "$11,892.44",
  },
  {
    name: "Ingrid Fischer",
    flag: germany,
    quote:
      "Their mobile app is incredibly well-designed. I can monitor positions and make trades seamlessly while traveling for my day job. True flexibility.",
    value: "$3,756.81",
  },
  {
    name: "Alessandro Romano",
    flag: italy,
    quote:
      "The psychological support from URFX's coaching team helped me overcome revenge trading. They care about trader development, not just profits.",
    value: "$13,467.29",
  },
  {
    name: "Gustav Nilsson",
    flag: sweden,
    quote:
      "Risk parameters are clearly defined and fair. No moving goalposts or surprise rule changes. URFX maintains professional standards consistently.",
    value: "$8,591.73",
  },
  {
    name: "Raj Gupta",
    flag: india,
    quote:
      "The account management dashboard provides incredible insights into my trading patterns. I've identified and fixed weaknesses I never knew I had.",
    value: "$7,428.96",
  },
  {
    name: "Tyler Brooks",
    flag: usa,
    quote:
      "Customer support responds within hours, not days. When you're trading live markets, that responsiveness can make or break your experience.",
    value: "$16,783.52",
  },
  {
    name: "Rafael Mendoza",
    flag: brazil,
    quote:
      "The profit sharing model rewards consistency over reckless gains. Finally, a firm that aligns with sustainable trading practices.",
    value: "$9,647.18",
  },
  {
    name: "Petra Hoffman",
    flag: germany,
    quote:
      "Their webinars and market analysis helped me understand institutional trading better. The educational value goes far beyond just providing capital.",
    value: "$5,319.65",
  },
  {
    name: "Giulia Ferrari",
    flag: italy,
    quote:
      "URFX doesn't micromanage your trading style. As long as you follow risk rules, they give you complete freedom to implement your strategy.",
    value: "$12,175.83",
  },
  {
    name: "Magnus Eriksson",
    flag: sweden,
    quote:
      "The evaluation criteria focus on real trading skills rather than luck. Passing their challenge actually means something in this industry.",
    value: "$4,962.37",
  },
  {
    name: "Sneha Patel",
    flag: india,
    quote:
      "Being part of URFX's trader network opened doors to collaborations and mentorship I never expected. The community aspect is incredibly valuable.",
    value: "$14,529.71",
  },
  {
    name: "Connor Davis",
    flag: usa,
    quote:
      "Their platform integration with TradingView and MT5 is flawless. I can use all my favorite tools without any technical complications.",
    value: "$10,891.46",
  },
  {
    name: "Marina Santos",
    flag: brazil,
    quote:
      "The monthly performance reviews help me stay on track with my goals. URFX provides structure that improved my discipline significantly.",
    value: "$6,734.92",
  },
];

const testimonials2: TestimonialStripItem[] = [
  {
    name: "Arjun Mehta",
    flag: india,
    quote:
      "The risk management tools provided by URFX helped me maintain consistency. Their analytics dashboard gives insights that improved my decision-making process dramatically.",
    value: "$11,746.23",
  },
  {
    name: "Klaus Zimmermann",
    flag: switzerland,
    quote:
      "I've been trading for years, but URFX's mentorship program took my skills to the next level. The feedback from their team is invaluable for growth.",
    value: "$8,529.67",
  },
  {
    name: "Astrid Larsen",
    flag: norway,
    quote:
      "The withdrawal process is seamless and professional. No hidden fees or delays - exactly what you'd expect from a reputable firm. URFX delivers on their promises.",
    value: "$7,394.81",
  },
  {
    name: "Diego Rodriguez",
    flag: spain,
    quote:
      "Their customer service team is exceptional. Whenever I had technical issues or questions about rules, they responded quickly with clear, helpful answers.",
    value: "$5,612.44",
  },
  {
    name: "Kenji Nakamura",
    flag: japan,
    quote:
      "The trading conditions are realistic and achievable. URFX created an environment where skilled traders can thrive without unrealistic pressure or impossible targets.",
    value: "$13,891.56",
  },
  {
    name: "Fatima Al-Zahra",
    flag: uae,
    quote:
      "Being able to trade from anywhere in the world with full support is amazing. URFX's global approach makes it perfect for international traders like myself.",
    value: "$9,674.32",
  },
  {
    name: "William Davies",
    flag: uk,
    quote:
      "The profit sharing model is fair and transparent. URFX doesn't just take from traders - they invest in your success and share the rewards genuinely.",
    value: "$12,238.95",
  },
  {
    name: "Vikram Singh",
    flag: india,
    quote:
      "Their advanced charting tools and real-time data feeds give me a competitive edge. The technology infrastructure is enterprise-level quality.",
    value: "$15,673.89",
  },
  {
    name: "Stefan Müller",
    flag: switzerland,
    quote:
      "The evaluation process tests real trading skills, not gambling instincts. URFX attracts serious traders who understand risk management.",
    value: "$6,847.25",
  },
  {
    name: "Lena Andersen",
    flag: norway,
    quote:
      "Monthly profit targets are achievable without taking excessive risks. URFX designed their program for long-term success, not quick burnouts.",
    value: "$10,529.13",
  },
  {
    name: "Carlos Ruiz",
    flag: spain,
    quote:
      "The trading simulator helped me practice strategies risk-free before going live. That preparation made all the difference in my performance.",
    value: "$8,765.47",
  },
  {
    name: "Yuki Sato",
    flag: japan,
    quote:
      "URFX's global market access allows me to trade sessions that fit my lifestyle. No restrictions on when or how I execute my strategies.",
    value: "$14,982.64",
  },
  {
    name: "Layla Rahman",
    flag: uae,
    quote:
      "The educational workshops improved my understanding of market psychology. URFX invests in trader development, not just capital allocation.",
    value: "$7,156.38",
  },
  {
    name: "Michael Thompson",
    flag: uk,
    quote:
      "Risk-to-reward ratios are clearly defined and fair. I can focus on trading instead of worrying about hidden restrictions or changing rules.",
    value: "$11,394.72",
  },
  {
    name: "Deepak Kumar",
    flag: india,
    quote:
      "The performance analytics help me identify patterns in my trading behavior. This data-driven approach improved my consistency dramatically.",
    value: "$9,213.85",
  },
  {
    name: "Thomas Berger",
    flag: switzerland,
    quote:
      "Their copytrading features allow me to learn from successful strategies. URFX creates an environment where knowledge sharing benefits everyone.",
    value: "$13,756.21",
  },
  {
    name: "Ingrid Olsen",
    flag: norway,
    quote:
      "The account scaling happens automatically based on performance metrics. No need to apply or wait - consistent profits unlock higher capital tiers.",
    value: "$5,482.94",
  },
  {
    name: "Alejandro Morales",
    flag: spain,
    quote:
      "URFX's partnership with institutional brokers provides better execution than retail platforms. The professional trading environment makes a real difference.",
    value: "$16,847.56",
  },
  {
    name: "Takeshi Yamamoto",
    flag: japan,
    quote:
      "The community forums are active with experienced traders sharing insights. Learning from peers has accelerated my development significantly.",
    value: "$12,639.17",
  },
  {
    name: "Noor Al-Mansouri",
    flag: uae,
    quote:
      "Tax reporting tools make compliance easy across different jurisdictions. URFX handles the complexity so I can focus on what I do best - trading.",
    value: "$8,374.63",
  },
];

function VerticalStripCard({
  testimonial,
}: {
  testimonial: TestimonialStripItem;
}) {
  return (
    <div className="card-gradient card-gradient--scroll-strip shrink-0 w-full rounded-[32px] ">
      <div className="flex min-h-[140px] flex-col justify-between gap-3 p-4">
        <p className="font-creato text-2xl font-normal italic text-white/85 line-clamp-4 md:text-[28px]">
          &ldquo;{testimonial.quote}&rdquo;
        </p>
        <div className="flex items-end justify-between gap-2">
          <div className="min-w-0">
            <h3 className=" font-nexa text-base italic font-normal text-white md:text-lg">
              {testimonial.name}
            </h3>
            <p className="font-creato text-[11px] text-white/50 sm:text-base ">
              {testimonial.value}
            </p>
          </div>
          <img
            src={testimonial.flag}
            alt="flag logo"
            className="h-6 w-6 shrink-0 rounded-full object-cover ring-1 ring-white/15"
          />
        </div>
      </div>
    </div>
  );
}

/** Mobile / tablet: always-on gradient frame (full `card-gradient`, not scroll-strip idle) */
function MobileSwiperCard({ testimonial }: { testimonial: TestimonialStripItem }) {
  return (
    <div className="card-gradient !shadow-none card-gradient--mobile-swiper mx-auto w-full max-w-md md:shadow-[0_0_90px_rgba(185,214,82,0.18)]">
      <div className="flex min-h-[168px] flex-col justify-between gap-4 p-5 sm:min-h-[180px]">
        <p className="font-creato italic font-normal leading-snug text-white/90 line-clamp-5 text-xl">
          &ldquo;{testimonial.quote}&rdquo;
        </p>
        <div className="flex items-end justify-between gap-3">
          <div className="min-w-0">
            <h3 className="truncate italic font-nexa text-base font-normal text-white md:text-lg">
              {testimonial.name}
            </h3>
            <p className="font-creato text-sm text-white/50">
              {testimonial.value}
            </p>
          </div>
          <img
            src={testimonial.flag}
            alt="flag logo"
            className="h-8 w-8 shrink-0 rounded-full object-cover ring-2 ring-white/15"
          />
        </div>
      </div>
    </div>
  );
}

/** Swiper carousel for viewports below `lg` (matches BlogSection mobile pattern) */
export function TestimonialsCarouselMobile() {
  const items = useMemo(
    () => [...testimonials, ...testimonials2],
    []
  );

  return (
    <Swiper
      modules={[Pagination]}
      pagination={{ clickable: true }}
      spaceBetween={16}
      slidesPerView={1.1}
      breakpoints={{
        640: { slidesPerView: 1, spaceBetween: 18 },
        800: { slidesPerView: 2, spaceBetween: 20 },
      }}
      className="pb-10 payout-swiper !py-20"
    >
      {items.map((testimonial, index) => (
        <SwiperSlide key={`${testimonial.name}-${index}`} className="h-auto py-6">
          <MobileSwiperCard testimonial={testimonial} />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export type TestimonialsScrollSectionProps = {
  variant?: "horizontal" | "vertical";
  /** Which dataset to scroll; vertical columns use different lists per side */
  column?: "left" | "right";
  /** Vertical motion: left column typically scrolls up, right scrolls down */
  verticalDirection?: "up" | "down";
};

export default function TestimonialsScrollSection({
  variant = "horizontal",
  column = "left",
  verticalDirection,
}: TestimonialsScrollSectionProps) {
  const items = column === "right" ? testimonials2 : testimonials;
  const vDir = verticalDirection ?? (column === "right" ? "down" : "up");

  if (variant === "vertical") {
    const loop = [...items, ...items];
    return (
      <div className="relative h-[min(72vh,640px)] w-full overflow-hidden md:h-[min(78vh,720px)]">
        <div
          className="pointer-events-none absolute inset-x-0 top-0 z-10 h-20 bg-gradient-to-b from-black to-transparent"
          aria-hidden
        />
        <div
          className="pointer-events-none absolute inset-x-0 bottom-0 z-10 h-20 bg-gradient-to-t from-black to-transparent"
          aria-hidden
        />
        <div
          className={`testimonial-marquee-column flex w-full flex-col gap-3 ${
            vDir === "up" ? "animate-scroll-up" : "animate-scroll-down"
          }`}
        >
          {loop.map((testimonial, index) => (
            <VerticalStripCard
              key={`${testimonial.name}-${index}`}
              testimonial={testimonial}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="scrollbar-hide w-full overflow-hidden">
      <div className="flex min-w-full flex-col gap-4">
        <div className="animate-scroll-left flex flex-row justify-start gap-2">
          {testimonials.map((testimonial, index) => (
            <div key={`top-${index}`} className="ml-2 flex-shrink-0 sm:w-fit">
              <TestimonialCard className="w-full bg-white/10">
                <div className="relative flex h-full w-full flex-col justify-between p-2">
                  <div className="flex h-full w-full flex-col justify-between p-3 2k:p-6">
                    <div className="relative">
                      <p className="relative z-10 font-creato text-sm font-medium text-gray-300 md:text-base">
                        &ldquo;{testimonial.quote}&rdquo;
                      </p> 
                    </div>
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex h-full flex-col justify-between">
                        <h3 className="text-lg font-semibold text-white md:text-xl">
                          {testimonial.name}
                        </h3>
                        <div className="flex items-center">
                          <p className="text-[12px]  opacity-50 text-white sm:text-[17px] 2k:text-[28px]">
                            {testimonial.value}
                          </p>
                        </div>
                      </div>
                      <img
                        src={testimonial.flag}
                        alt="flag logo"
                        className="h-6 w-6"
                      />
                    </div>
                  </div>
                </div>
              </TestimonialCard>
            </div>
          ))}
        </div>

        <div className="animate-scroll-right flex flex-row justify-start gap-2">
          {testimonials2.map((testimonial, index) => (
            <div key={`bottom-${index}`} className="ml-2 flex-shrink-0 sm:w-fit">
              <TestimonialCard className="w-full bg-white/10">
                <div className="relative flex h-full w-full flex-col justify-between p-2">
                  <div className="flex h-full w-full flex-col justify-between p-3 2k:p-6">
                    <div className="relative">
                      <p className="relative z-10 font-creato text-sm font-medium text-gray-300 md:text-base">
                        &ldquo;{testimonial.quote}&rdquo;
                      </p>
                    </div>
                    <div className="flex items-center justify-between gap-4">
                      <div className="flex h-full flex-col justify-between">
                        <h3 className="text-lg font-semibold text-white md:text-xl">
                          {testimonial.name}
                        </h3>
                        <div className="flex items-center">
                          <p className="text-[12px]  opacity-50 text-white sm:text-[17px] 2k:text-[28px]">
                            {testimonial.value}
                          </p>
                        </div>
                      </div>
                      <img
                        src={testimonial.flag}
                        alt="flag logo"
                        className="h-6 w-6"
                      />
                    </div>
                  </div>
                </div>
              </TestimonialCard>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
